/* ============================================================================
   csf-footer.js — small UX helper for the custom footer newsletter.
   The form itself is a native Shopify {% form 'customer' %} (works without JS);
   this only auto-clears the input after a successful submit redirect and keeps
   the success/error note in view. Scoped to .csf-ft, safe to load globally.
   ========================================================================== */
(function () {
  function init(root) {
    (root || document).querySelectorAll('.csf-ft__form').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      var note = form.parentElement.querySelector('.csf-ft__news-note.is-ok');
      if (note) {
        // Bring the confirmation into view on the reload after subscribing.
        try { note.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
        var input = form.querySelector('input[type="email"]');
        if (input) input.value = '';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
